<template>
  <div class="profile-view-advocacy-template">
    <div class="resource-item-container">
      <!-- <div class="resource-body" v-for="(stuff, indx) in info.userOrganization.careplans" v-if="stuff.careplan.is_approved && stuff.careplan.type!='report_concern' && stuff.careplan.type!='suggestion_box' && stuff.careplan.type!='menu' && stuff.careplan.type!='video' && stuff.careplan.type!='maintainance'" :key="indx">
        <div>
          <FeedListView :avatar="stuff.careplan.thumbnail_photo"
            :title="stuff.careplan.title"
            :item="stuff"
            :poster="stuff.careplan.type"
            @emitContainer="onTriggerStuff(stuff)">
              <template slot="add-option" v-if="profileInfo.id == info.data.id">
                <div style="position:absolute;right:20px;z-index:1">
                  <span v-if="info.data.primary_org === stuff.careplan.id" @click="setPrimaryOrg(stuff, 'unset')">
                    <Icon type="android-star" class="stroked-star" style="color:orange" size="30"></Icon>
                  </span>
                  <span v-else @click="setPrimaryOrg(stuff, 'set')">
                    <Icon type="android-star-outline" size="33"></Icon>
                  </span>
                </div>
              </template>
            </FeedListView>
        </div>
      </div> -->
      <div class="resource-body" v-for="(stuff, indx) in info.userOrganization.careplans"
        style="margin-bottom:10px" @click="onSetPrimaryOrg(stuff.careplan)"
        v-if="stuff.careplan.is_approved" :key="indx">
        <div class="r-title-containter" style="display:inline-block;margin-right:10px">
          <Avatar :src="stuff.careplan | getDisplayImage" shape="square" size="large"></Avatar>
        </div>
        <div class="r-title-containter" style="display:inline-block">
          {{stuff.careplan.title}}
          <span v-if="isSelectedID == stuff.careplan.id">
            <a><Icon type="checkmark-circled" size="15"></Icon></a>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import FeedListView from "@/components/FeedListView";
  import Utils from '@/utils.js'

  export default {
    components: { FeedListView },
    data() {
      return {
        selected: null
      }
    },
    methods: {
      onSetPrimaryOrg(o) {
        this.selected = o.id
        BroadcastEvent.$emit('SETNEWSELECTEDORG', o.id)
      },
      setPrimaryOrg(stuff, set) {
        let data = {
          'meta': {'primary_org': (set == 'set') ? stuff.careplan.id:null}
        };
        this.$store.dispatch('publicProfile/setPrimaryOrg', {id:this.profileInfo.id, data})
          .then(res => {
          this.info.data.primary_org = res.primary_org
        });
      },
      groupDisplayImage(stuff) {
        return Utils.getDisplayImage('group', stuff, 'small')
      },
      onTriggerStuff(data) {
        this.$router.push("/resources/" + data.careplan_id);
      },
      loadGroups() {
        this.$store.dispatch('publicProfile/getUserOrganization', {id:this.uid});
      }
    },
    watch: {
      '$route': function(n,o) {
        if (n) this.loadGroups()
      }
    },
    filters: {
      getDisplayImage(data) {
        return Utils.getDisplayImage('group', data, 'small')
      }
    },
    mounted() {
      this.loadGroups()
    },
    computed: {
      isSelectedID: {
        get() {
          if( this.selected ) {
            return this.selected
          } else {
            return this.profile.primary_org
          }
        },
         set(v) {
           this.selected = v;
         }
      },
      profileInfo: {
        get() {
          return this.$store.state.user.info;
        }
      },
      info: {
        get() {
          return this.$store.state.publicProfile.info
        }
      }
    },
    props: {
      profile: {
        type: Object
      },
      uid: {
        required: true,
        type: String,
        default: ""
      }
    }
  }
</script>

<style scoped>
  .stroked-star {
    -webkit-text-stroke: 2px;
    -webkit-text-stroke-color: #494f61;
  }
</style>
